module.exports = __webpack_public_path__ + "static/media/order-plus-circle.40b3537c.svg";